/* Magia Viral · scripts del tema */
document.addEventListener('DOMContentLoaded', function () {

  /* 1) Junta los videos de la descripción en una cuadrícula */
  document.querySelectorAll('.product-template-section .description').forEach(function (desc) {
    var envolturas = Array.prototype.slice
      .call(desc.querySelectorAll('iframe[src*="vimeo"], iframe[src*="youtube"]'))
      .map(function (f) { return f.parentElement; })
      .filter(function (w, i, arr) { return w !== desc && arr.indexOf(w) === i; });
    if (envolturas.length < 2) return;
    var grid = document.createElement('div');
    grid.className = 'mv-videos';
    envolturas[0].parentNode.insertBefore(grid, envolturas[0]);
    envolturas.forEach(function (w) { grid.appendChild(w); });
  });

  /* 1.5) Da estructura a la descripción: subtítulos, destacados, citas, listas y botones */
  document.querySelectorAll('.product-template-section .description[itemprop="description"]').forEach(function (d) {
    if (d.dataset.mvOk) return;
    d.dataset.mvOk = '1';

    // separa en renglones los párrafos tipo "- punto<br>- punto<br>- punto"
    // y los párrafos que en realidad son dos o más pegados con doble salto de línea
    Array.prototype.slice.call(d.querySelectorAll(':scope > p')).forEach(function (p) {
      var partes = p.innerHTML.split(/<br\s*\/?>/i);
      if (partes.length < 2) return;
      var conGuion = partes.filter(function (h) {
        var t = h.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();
        return /^[-–•]\s/.test(t);
      });
      if (conGuion.length < 2) {
        partes = p.innerHTML.split(/(?:<br\s*\/?>\s*(?:<\/?span[^>]*>\s*)*){2,}/i);
        if (partes.length < 2) return;
      }
      partes.forEach(function (h) {
        if (!h.replace(/<[^>]+>/g, '').trim()) return;
        var np = document.createElement('p');
        np.innerHTML = h;
        p.parentNode.insertBefore(np, p);
      });
      p.parentNode.removeChild(p);
    });

    var hijos = Array.prototype.slice.call(d.querySelectorAll(':scope > p, :scope > h2, :scope > h3, :scope > div:not(.mv-videos)'));
    var hayLead = false;

    hijos.forEach(function (el) {
      var t = el.textContent.replace(/\s+/g, ' ').trim();
      if (!t && !el.querySelector('img,iframe,video')) { el.classList.add('mv-vacio'); return; }
      if (!t) return;

      var enlaces = Array.prototype.slice.call(el.querySelectorAll('a')).filter(function (x) { return !x.querySelector('img'); });
      var negritas = Array.prototype.map.call(el.querySelectorAll('strong,b'), function (x) { return x.textContent; })
        .join('').replace(/\s+/g, ' ').trim();
      var todoNegrita = negritas.length >= t.length * 0.9;
      var letras = t.replace(/[^A-Za-zÁÉÍÓÚÑáéíóúñ]/g, '');
      var mayus = letras.replace(/[^A-ZÁÉÍÓÚÑ]/g, '').length / (letras.length || 1);

      // botón: enlaces de llamada a la acción
      if (enlaces.length && /clic aqu|whatsapp|quiero|webinar|acceder/i.test(t) && t.length < 140) {
        var primero = enlaces[0];
        // une enlaces partidos que van al mismo lugar ("[QUIERO APRENDER…" + "CLIC AQUÍ]")
        enlaces.slice(1).forEach(function (x) {
          if (x.getAttribute('href') === primero.getAttribute('href')) {
            primero.appendChild(document.createTextNode(' ' + x.textContent));
            x.parentNode.removeChild(x);
          } else {
            x.classList.add('mv-cta');
          }
        });
        primero.textContent = primero.textContent.replace(/[\[\]]/g, '').replace(/\s+/g, ' ').trim();
        primero.classList.add('mv-cta');
        // enlaces para quien ya compró: botón secundario
        if (/compraste|ya lo compr|acceder/i.test(primero.textContent)) primero.classList.add('mv-cta--sec');
        el.classList.add('mv-cta-wrap');
        return;
      }
      // viñeta: renglones que empiezan con guion
      if (/^[-–•]\s/.test(t)) {
        el.classList.add('mv-item');
        el.innerHTML = el.innerHTML.replace(/^((?:\s|&nbsp;|<[^>]+>)*)[-–•]\s*/, '$1');
        return;
      }
      if (el.tagName !== 'P') return;
      // subtítulo: frase corta en negritas o que termina en dos puntos
      if ((todoNegrita && t.length <= 70) || (t.length <= 60 && /:$/.test(t))) { el.classList.add('mv-subhead'); return; }
      // destacado: párrafo largo todo en negritas
      if (todoNegrita) { el.classList.add('mv-callout'); return; }
      // cita: frase corta casi toda en mayúsculas
      if (mayus > 0.7 && t.length < 200) { el.classList.add('mv-quote'); return; }
      // primer párrafo largo: entrada más grande
      if (!hayLead && t.length > 140) { el.classList.add('mv-lead'); hayLead = true; }
    });

    // une botones seguidos que llevan al mismo lugar (renglones partidos en dos párrafos)
    Array.prototype.slice.call(d.querySelectorAll(':scope > .mv-cta-wrap')).forEach(function (w) {
      if (!w.isConnected) return;
      var a1 = w.querySelector('a.mv-cta');
      var sig = w.nextElementSibling;
      while (sig && sig.classList.contains('mv-vacio')) sig = sig.nextElementSibling;
      if (!a1 || !sig || !sig.classList.contains('mv-cta-wrap')) return;
      var a2 = sig.querySelector('a.mv-cta');
      if (a2 && a2.getAttribute('href') === a1.getAttribute('href')) {
        a1.textContent = (a1.textContent + ' ' + a2.textContent).replace(/[\[\]]/g, '').replace(/\s+/g, ' ').trim();
        sig.parentNode.removeChild(sig);
      }
    });

    // agrupa viñetas seguidas en una sola tarjeta
    Array.prototype.slice.call(d.querySelectorAll(':scope > .mv-item')).forEach(function (it) {
      var prev = it.previousElementSibling;
      while (prev && prev.classList.contains('mv-vacio')) prev = prev.previousElementSibling;
      if (prev && prev.classList.contains('mv-checklist')) { prev.appendChild(it); return; }
      var caja = document.createElement('div');
      caja.className = 'mv-checklist';
      it.parentNode.insertBefore(caja, it);
      caja.appendChild(it);
    });

    // encabezado de la sección
    var cab = document.createElement('div');
    cab.className = 'mv-desc-head';
    cab.innerHTML = '<span class="mv-desc-head__eyebrow">♠  Detalles  ♦</span>' +
                    '<h2 class="mv-desc-head__title">Todo lo que necesitas saber</h2>';
    d.insertAdjacentElement('beforebegin', cab);
  });

  /* 2) Descripción plegable */
  var LIMITE = 1100;
  document.querySelectorAll('.product-template-section .description[itemprop="description"]').forEach(function (desc) {
    if (desc.scrollHeight < LIMITE + 200) return;
    desc.classList.add('mv-desc');
    if (!desc.id) desc.id = 'mv-desc-' + Math.random().toString(36).slice(2, 8);
    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'mv-desc-toggle';
    boton.setAttribute('aria-expanded', 'false');
    boton.setAttribute('aria-controls', desc.id);
    boton.textContent = 'Leer descripción completa';
    boton.addEventListener('click', function () {
      var abierto = desc.classList.toggle('is-open');
      boton.setAttribute('aria-expanded', abierto);
      boton.textContent = abierto ? 'Ver menos' : 'Leer descripción completa';
      if (!abierto) desc.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    desc.insertAdjacentElement('afterend', boton);
  });

  /* 3) Limpia encabezados y listas vacías en páginas de información */
  document.querySelectorAll('.sidebar-template-section .section :is(h2,h3,h4,ul,ol,p)').forEach(function (el) {
    if (!el.textContent.trim() && !el.querySelector('img,iframe,video')) el.classList.add('mv-vacio');
  });
});

/* ===== Menú de celular: lo abrimos y cerramos nosotros (sin la animación del tema) ===== */
(function () {
  function iniciarMenu() {
    var boton = document.querySelector('.header-section a.navicon');
    var menu = document.querySelector('.header-section .mobile_menu');
    if (!boton || !menu || boton.dataset.mvMenu) return;
    boton.dataset.mvMenu = '1';
    boton.setAttribute('aria-expanded', 'false');

    function abrir(si) {
      document.body.classList.toggle('mv-menu-open', si);
      boton.setAttribute('aria-expanded', si ? 'true' : 'false');
      menu.removeAttribute('style');            // borra lo que deje el tema
    }

    // fase de captura: llega antes que el código del tema y lo detiene
    window.addEventListener('click', function (e) {
      var dentroBoton = e.target.closest && e.target.closest('.header-section a.navicon');
      if (dentroBoton) {
        e.preventDefault();
        e.stopImmediatePropagation();
        abrir(!document.body.classList.contains('mv-menu-open'));
        return;
      }
      // tocar fuera del menú lo cierra
      if (document.body.classList.contains('mv-menu-open') &&
          !e.target.closest('.header-section .mobile_menu')) {
        abrir(false);
      }
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') abrir(false);
    });
    // si se agranda la pantalla a escritorio, se cierra
    window.addEventListener('resize', function () {
      if (window.innerWidth > 767) abrir(false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarMenu);
  else iniciarMenu();
})();